import { Toast } from 'vant'
import router from "@/router/index"
let isLoadingShow = false
let duration = 5000

export default {
    handleError(code, error) {
        const errorData = error.response.data
        if (code === 400 || code === 500) {
            //后台业务错误
            if (errorData.error) {
                this.showFailToast(errorData.error)
            } else if (errorData.error_msg) {
                this.showFailToast(errorData.error_msg)
            }
            else if (errorData.result) {
                if (errorData.result.message) {
                    this.showFailToast(errorData.result.message)
                } else {
                    this.showFailToast(errorData.result)
                }

            }

        }
        if (code === 403) {
             // 处理 403 错误，不上报 Sentry
            console.warn("403 错误已忽略：", error);
            router.push('/auths/WechatAuth')
        }
        return null
    },
    showLoading() {
        if (!isLoadingShow) {
            isLoadingShow = true
            Toast.loading({
                duration: duration,
                forbidClick: true,
                message: "加载中...",
            });
        }

    },
    hideLoading() {
        isLoadingShow = false
        Toast.clear();
    },

    showFailToast(message, options = {}) {
        Toast.clear();
        Toast.fail(message, options);
    },
    // 清除所有Toast
    clearToast() {
        Toast.clear();
    }

}